<template>
  <v-main>
    <v-container fluid>
      <v-alert id="alert" v-model="alert.isAlert" :type="alert.type" closable class="row">{{ alert.message }}</v-alert>
      <v-row v-if="isShow" align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-card-title>パスワード発行</v-card-title>
            <v-card-subtitle style="white-space: pre-wrap"> パスワードの設定・変更用のURLを登録済みメールアドレスへお送りいたします。 </v-card-subtitle>
            <v-card-text>
              <v-form>
                <v-text-field
                  id="userId"
                  v-model="userId"
                  :prepend-icon="mdiAccount"
                  placeholder="ログインID"
                  type="text"
                  maxlength="256"
                  variant="underlined"
                  density="compact"
                  @keyup.enter="send"
                ></v-text-field>

                <v-text-field
                  id="userEmail"
                  v-model="userEmail"
                  :prepend-icon="mdiEmail"
                  placeholder="登録済メールアドレス"
                  type="email"
                  maxlength="256"
                  variant="underlined"
                  density="compact"
                  @keyup.enter="send"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn id="cancel" variant="elevated" class="mr-10 mb-10" @click="cancel">キャンセル</v-btn>
              <v-btn id="send" variant="elevated" class="ml-10 mb-10" color="primary" :disabled="isButtonDisabled" @click="send">送信</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import Api from '@/constants/api';
import { mdiAccount, mdiEmail } from '@mdi/js';

export default {
  data: () => ({
    isShow: true,
    userId: '',
    userEmail: '',
    isButtonDisabled: false,
    alert: {
      isAlert: false,
      type: 'success',
      message: '',
    },
    mdiAccount,
    mdiEmail,
  }),
  methods: {
    send: async function () {
      this.isButtonDisabled = true;
      try {
        if (!this.userId) {
          this.showAlert('warning', 'ログインIDを入力してください。');
          return;
        } else if (!this.userEmail) {
          this.showAlert('warning', '登録済メールアドレスを入力してください。');
          return;
        }
        let passwordResponse = await this.axios.post(Api.PATH_PASSWORD_REISSUE, {
          mypage_user_id: this.userId,
          mypage_user_email: this.userEmail,
        });
        if (passwordResponse != null) {
          if (passwordResponse.data.status == Api.STATUS_SUCCESS) {
            this.isShow = false;
            this.showAlert('success', 'パスワードの設定・変更用のURLを登録済みメールアドレスへ送信しました。');
            return;
          } else if (passwordResponse.data.status == Api.STATUS_PARAM_ERROR) {
            this.showAlert('warning', '入力内容が正しくありません。再度ご確認ください。');
            return;
          } else {
            throw 'API_PASSWORD_REISSUE failed.';
          }
        } else {
          throw 'API_PASSWORD_REISSUE failed.';
        }
      } finally {
        this.userId = '';
        this.userEmail = '';
        this.isButtonDisabled = false;
      }
    },
    cancel: function () {
      this.$router.push({ name: 'Login' });
    },
    createAlert: function (type, message) {
      return {
        isAlert: true,
        type: type,
        message: message,
      };
    },
    showAlert: function (type, message) {
      this.alert.isAlert = true;
      this.alert.type = type;
      this.alert.message = message;
    },
  },
};
</script>
